module.exports = __webpack_public_path__ + "static/media/alert-light-green-on.879ff1c2.png";